import { render, staticRenderFns } from "./address-personal.vue?vue&type=template&id=317622d4"
import script from "./address-personal.vue?vue&type=script&lang=js"
export * from "./address-personal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports